// extracted by mini-css-extract-plugin
module.exports = {"Layout":"index-module--Layout--1XsT3","Content":"index-module--Content--1D_nF","Header":"index-module--Header--3VdGV"};